import { DragOverlay, useDndContext } from '@dnd-kit/core';

import { Table } from '@ui/components/Table';

import { ParticipantDto, TournamentTeam } from '@features/shared/api/typings';
import { ParticipantRowPreview } from '@features/tournament/ui/components/TournamentParticipantsEdit/components/ParticipantRow';
import { DROP_ANIMATION_SETTINGS } from '@features/tournament/ui/components/TournamentParticipantsEdit/components/participantsHelpers';
import { TeamRowPreview } from '@features/tournament/ui/components/TournamentParticipantsEdit/components/TeamRow';

import styles from '../TournamentParticipantsEdit.module.css';

type ParticipantDragPreviewProps = {
  participants?: ParticipantDto[];
  teams?: TournamentTeam[];
  isRcf: boolean;
  showCameras?: boolean;
  isSchoolEvent: boolean;
};

export function DragPreview({
  participants,
  teams,
  isRcf,
  showCameras,
  isSchoolEvent,
}: ParticipantDragPreviewProps) {
  const { active } = useDndContext();
  const activeParticipant = active && participants?.find((p) => p.userId === active.id);
  const activeTeam = active && teams?.find((t) => t.teamId === active.id);

  return (
    <DragOverlay dropAnimation={activeParticipant ? DROP_ANIMATION_SETTINGS : null}>
      {activeParticipant && (
        <Table className={styles.table}>
          <ParticipantRowPreview
            participant={activeParticipant}
            isRcf={isRcf}
            showCameras={showCameras}
            isSchoolEvent={isSchoolEvent}
          />
        </Table>
      )}

      {activeTeam && (
        <Table className={styles.table}>
          <TeamRowPreview
            num={((activeTeam && teams?.indexOf(activeTeam)) || 0) + 1}
            name={activeTeam?.name || ''}
            isRcf={isRcf}
            showCameras={showCameras}
            isSchoolEvent={isSchoolEvent}
          />
        </Table>
      )}
    </DragOverlay>
  );
}
